export const whatsappOrderLink = (product, size) => {
  const number = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
  const lines = [
    "Hi Hunar Designs! I'd like to place an order:",
    "",
    `• ${product.name} — ₹${Number(product.price).toLocaleString("en-IN")}`,
  ];
  if (size) lines.push(`• Size: ${size}`);
  lines.push("", `Product: ${window.location.origin}/product/${product.id}`, "", "Please share payment and delivery details.");
  return `https://wa.me/${number}?text=${encodeURIComponent(lines.join("\n"))}`;
};
